import script from "./MainPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainPage.vue?vue&type=script&setup=true&lang=ts"

import "./MainPage.vue?vue&type=style&index=0&id=68d3f66e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68d3f66e"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
